import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import client from "@/lib/api";

export function PagoExito() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("Confirmando tu pago…");

    useEffect(() => {
        const sid = params.get("session_id");
        if (!sid) { navigate("/app/resultado"); return; }
        let tries = 0;
        const tick = async () => {
            tries += 1;
            try {
                const { data } = await client.get(`/payments/status/${sid}`);
                if (data.payment_status === "paid") {
                    setMsg("¡Listo! Abriendo tu análisis…");
                    setTimeout(() => navigate("/app/resultado"), 900);
                    return;
                }
            } catch (e) {}
            if (tries < 12) setTimeout(tick, 2000);
            else setMsg("El pago está tardando en confirmarse. Vuelve a tu resultado en un momento.");
        };
        tick();
    }, [params, navigate]);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
            <Brand />
            <div className="mt-8 h-10 w-10 rounded-full border-2 border-line border-t-terracotta animate-spin" />
            <p className="mt-6 text-[16px] text-ink">{msg}</p>
            <Button asChild variant="ghost" className="mt-4"><Link to="/app/resultado">Ir a mi resultado</Link></Button>
        </div>
    );
}

export function PagoCancelado() {
    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
            <Brand />
            <h1 className="mt-8 font-display text-[26px] font-bold text-ink">Has cancelado el pago</h1>
            <p className="mt-2 max-w-sm text-[16px] leading-[1.6] text-subtle">
                No te hemos cobrado nada. Tu Tabla Espejo sigue disponible y puedes desbloquear el análisis cuando quieras.
            </p>
            <Button asChild className="mt-6"><Link to="/app/resultado">Volver a mi resultado</Link></Button>
        </div>
    );
}
